<template>
  <div class="SAForm">
    <c-form
      class="form"
      :formData="formData"
      :fields="extFields"
      :options="options"
      ref="form"
      :upload="upload"
      labelWidth="120px"
      :area="area"
      @changeForm="osg.changeForm"
    ></c-form>
    <div class="footer">
      <el-button type="primary" @click="doSave">提 交</el-button>
      <el-button @click="doInit">取 消</el-button>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'ServiceAppointmentForm',
  data() {
    window.$this = this;
    return {
      paramObj: {},
      name: 'ServiceAppointmentForm',
      formData: {
        exts: {}
      },
      extFields: [],
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.doInit();
  },
  methods: {
    doInit() {
      this.paramObj = this.osg.paramObj();
      // 清除表单字段
      if (this.$refs.form && this.$refs.form.$refs.formData) {
        this.$refs.form.$refs.formData.resetFields();
      }
      this.osg.getFields(
        'declaration',
        () => {
          this.$util.renderExtField(this.extFields, this.formData);
          // 将地址栏参数赋值到表单
          let formData = {
            exts: {}
          };
          if (this.paramObj) {
            for (let key in this.paramObj) {
              for (let f of this.extFields) {
                if (f.name == key) {
                  if (f.preset) {
                    if (f.type == 'cascade' || f.multiple) {
                      formData[key] = this.paramObj[key] ? this.paramObj[key].split(',') : [];
                    } else {
                      formData[key] = this.paramObj[key];
                    }
                  } else {
                    if (f.type == 'cascade' || f.multiple) {
                      formData.exts[key] = this.paramObj[key] ? this.paramObj[key].split(',') : [];
                    } else {
                      formData.exts[key] = this.paramObj[key];
                    }
                  }
                  break;
                }
              }
            }
            this.formData = formData;
          }
          this.formData.tenantId = this.paramObj.tenantId;
          this.formData.createUser = this.paramObj.createUser;
          this.formData.createUserName = this.paramObj.createUserName;
          this.$forceUpdate();
        },
        null,
        null,
        null,
        this.paramObj.tenantId
      );

      // 本地私有化存储
      this.osg.tenantConfig.uploadMode = 2;
    },
    // 选择客户后，将客户部分信息赋值到工单上
    handleSelect(item) {
      let contactIds = this.formData.contactIds || [];
      if (contactIds.indexOf(item._id) == -1) contactIds.push(item._id);
      this.$set(this.formData, 'contactIds', contactIds);
      this.$set(this.formData, 'phone', item.phone);
      this.$set(this.formData, 'area', item.area);
      this.$set(this.formData, 'address', item.address);
    },
    // 保存工单
    doSave() {
      if (this.osg.validate()) {
        // 判断重复点击
        if (this.osg.isRepeatClick('doSA', 5000)) {
          return;
        }

        let params = this.formData;
        // 省市区街道area数组拆分为省、市、区、街道字段赋值
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }

        // 关联动态表单创建的工单需要在exts存bizType
        this.extFields.map(item => {
          if (item.frontEndConfig.setField) {
            if (item.frontEndConfig.setField.indexOf('.') != -1) {
              let key1 = item.frontEndConfig.setField.split('.')[0];
              let key2 = item.frontEndConfig.setField.split('.')[1];
              params[key1] = params[key1] || {};
              params[key1][key2] = item.frontEndConfig.setFieldValue;
            } else {
              let key = item.frontEndConfig.setField;
              params[key] = item.frontEndConfig.setFieldValue;
            }
          }
        });

        // 特殊类型字段数据格式转换
        this.$util.saveFormatExtField(this.extFields, params);

        this.osg.ajax(
          `s/upsert.do?id=${this.paramObj.tenantId}`,
          params,
          () => {
            this.osg.alert('提交成功', () => {
              this.doInit();
              window.parent.postMessage({ msg: 'closeLayer' }, '*');
            });
          },
          {
            header: { 'Content-Type': 'application/json', requestDataType: 'json' }
          }
        );
      }
    }
  }
};
</script>
<style scoped lang="scss">
.SAForm {
  height: 100vh;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .form {
    flex: 1;
    overflow: auto;
    ::v-deep .el-radio-group {
      display: flex;
    }
  }
  .footer {
    padding-top: 10px;
    text-align: center;
    border-top: 1px solid #e8eaec;
  }
}
</style>
